import React from 'react';
import styled from 'astroturf/react';

import Header, { Props as HeaderProps } from './Header';
import ThreeImages, { Props as ThreeImagesProps } from './ThreeImages';

export type Props = HeaderProps & ThreeImagesProps;

const Container = styled.div`
  padding: 40px calc(max(16px, (100% - 1130px) / 2)) 64px;

  @media screen and (min-width: 768px) {
    display: flex;
    gap: 46px;
    overflow-x: hidden;
  }
`;

const HeaderSection = styled.div`
  flex-basis: calc((100% - 46px) / 2);
  flex-shrink: 0;
  color: #222233;
`;

const ImagesSection = styled.div`
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

const TopSection: React.FunctionComponent<Props> = (props) => {
  return (
    <Container>
      <HeaderSection>
        <Header {...props} />
      </HeaderSection>
      <ImagesSection>
        <ThreeImages {...props} />
      </ImagesSection>
    </Container>
  );
};

export default TopSection;
